import { gql } from '__generated__/gql';

export const BOOKING_LIST_FRAGMENT = gql(`
  fragment BookingListOutput on HLBookingListOutput {
    status
    title
    refCode
    id
    responsibleUserId
    responsibleUser {
      id
      name
      email
    }
    publicCompany {
      id
      name
    }
    publicClient {
      id
      firstname
      lastname
    }
    offers {
      id
      status
      editingVersion {
        id
        status
      }
      latestVersion(type: [OFFER, RESERVATION_CONFIRMATION, INVOICE]) {
        id
        status
      }
      versions {
        id
        status
        type
      }
      hotel {
        id
        name
      }
    }
  }
`);

export const VIEW_BOOKING_QUERY = gql(`
  query ViewBooking($id: Int!) {
    viewBooking(id: $id) {
      ...BookingListOutput
    }
  }
`);

export const ASSIGN_BOOKING_MUTATION = gql(`
  mutation AssignBooking($bookingId: Int!, $userId: Int) {
    assignBooking(bookingId: $bookingId, userId: $userId) {
      ...BookingListOutput
    }
  }
`);

export const LIST_BOOKING_COMMENTS_QUERY = gql(`
  query ListBookingComments($bookingId: Int!) {
    listBookingComments(bookingId: $bookingId) {
      id
      description
      bookingId
      createdById
      createdBy {
        id
        name
        email
      }
      createdAt
      updatedAt
    }
  }
`);

export const LIST_COMPANY_COMMENTS_FOR_BOOKING_QUERY = gql(`
  query ListCompanyCommentsForBooking($companyId: Int!, $clientId: Int) {
    listCompanyComments(companyId: $companyId, clientId: $clientId) {
      id
      description
      isBookingRelevant
      isContactRelevant
      contactSubjectId
      contactSubject {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
        email
      }
      publicClient {
        id
        firstname
        lastname
      }
    }
  }
`);

export const CREATE_BOOKING_COMMENT_MUTATION = gql(`
  mutation CreateBookingComment($bookingId: Int!, $description: String!) {
    createBookingComment(bookingId: $bookingId, description: $description) {
      id
      description
      bookingId
      createdAt
    }
  }
`);

export const UPDATE_BOOKING_COMMENT_MUTATION = gql(`
  mutation UpdateBookingComment($id: Int!, $description: String!) {
    updateBookingComment(id: $id, description: $description) {
      id
      description
      updatedAt
    }
  }
`);

export const DELETE_BOOKING_COMMENT_MUTATION = gql(`
  mutation DeleteBookingComment($id: Int!) {
    deleteBookingComment(id: $id)
  }
`);

export const LIST_BOOKING_ASSIGNABLE_USERS_QUERY = gql(`
  query ListBookingAssignableUsers {
    listTaskUsers {
      id
      name
      isLocked
    }
  }
`);
